import { render } from "./ScenarioIntroduction.vue?vue&type=template&id=8ff7c6e6"
import script from "./ScenarioIntroduction.js?vue&type=script&lang=js"
export * from "./ScenarioIntroduction.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__